export default __webpack_public_path__ + "static/media/Asset 17.58501bb8.png";